export default {
    data() {
        return {
            selectedType: null,
            selectedSite: null,
            selectedDriver: null,
            selectedModelNumber: null,
            checkboxOrder: false,

            search: "",
            checkboxSelectAll: false,

            tourTypes: [],
            sites: [],
            modelNumbers: [],
            drivers: [],

            customers: [],
            selectedCustomers: [],
            customerInGroup: [],

            drag: false,

            loadingTourTypes: false,
            loadingSites: false,
            loadingModelNumbers: false,
            loadingDrivers: false,
            loadingSave: false,

            el: null,
            eventSet: false,
            scrollProgess: 0,
            page: 1,
            lastPage: 0,
            shouldRefresh: false
        };
    },
    methods: {
        async getTourTypes() {
            try {
                this.loadingTourTypes = true
                this.tourTypes = (await this.$api.tour_types.all()).data.data
                this.loadingTourTypes = false
            } catch (e) {
                this.loadingTourTypes = false
            }
        },
        async getDrivers() {
            try {
                this.loadingDrivers = true
                this.drivers = (await this.$api.drivers.all()).data.data
                this.loadingDrivers = false
            } catch (e) {
                this.loadingDrivers = false
            }
        },
        async getCustomers(options = {}) {
            const response = (await this.$api.customers.all(options)).data
            this.lastPage = response.meta.last_page
            return response.data
        },
        removeFromAList(to, from, index, element) {
            to.push(element)
            from.splice(index, 1)
            return {to, from}
        },
        removeFromSelected(index, element) {
            let data = this.removeFromAList(this.customers, this.selectedCustomers, index, element)
            this.customers = data.to
            this.selectedCustomers = data.from
        },
        removeFromCustomers(index, element) {
            let data = this.removeFromAList(this.selectedCustomers, this.customers, index, element)
            this.customers = this.customers.filter(item => item.id !== element.id);
            this.selectedCustomers = data.to
        },
        async save() {
            try {
                this.loadingSave = true
                const tourModelId = await this.createTourModel()
                await this.addCustomerToTourModel(tourModelId)
                this.loadingSave = false
                await this.$router.push({name: 'tours_models'})
            } catch (e) {
                this.loadingSave = false
            }
        },
        async createTourModel() {
            return (await this.$api.tour_models.create({
                driver_id: this.selectedDriver,
                tour_type_id: this.selectedType,
                model_number_id: this.selectedModelNumber,
                is_ordered: this.checkboxOrder
            })).data.id
        },
        async addCustomerToTourModel(id) {
            await this.$api.tour_models.customers(id,
                this.selectedCustomers.map((customer, index) => {
                    return {
                        customer_id: customer.id,
                        order: index
                    }
                }))
        },
        onScroll(ev) {
            let a = ev.target.scrollTop
            let b = ev.target.scrollHeight - ev.target.clientHeight
            this.shouldRefresh = parseInt(a / b * 100) > 80;
        },
        handleAddEvent() {
            if (!this.customerInGroup.length) {
                return
            }
            this.customerInGroup.map(customer => {
                const element = this.customers.find(element => element.id === customer)
                const index = this.customers.indexOf(element)
                if (index >= 0) {
                    this.removeFromCustomers(index, element)
                }
                this.customerInGroup = []
            })
        },
    },
    beforeUpdate() {
        if (this.eventSet === false) {
            this.el = this.$refs.lazyloading?.$el
            if (this.el) {
                this.el.addEventListener('scroll', ev => this.onScroll(ev))
                this.eventSet = true
            }
        }
    },
    computed: {
        selectAll: {
            get() {
                return this.customerInGroup.length === this.customers.length
            },
            set(value) {
                if (value) {
                    this.customerInGroup = this.customers.map(e => e.id)
                }
            }
        },
        filteredCustomers() {
            return this.customers.filter(customer => {
                return !this.selectedCustomers.map(e => e.id).includes(customer.id)
            });
        }
    },
    watch: {
        async shouldRefresh(value) {
            if (value) {
                await this.getNextPage()
            }
        },
        async customers(value) {
            if (value.length === 0) {
                await this.getNextPage()
            }
        },
        async search(value) {
            this.getSearch()
        }
    }
}
